import { IAuthenticationRegistry, IAuthenticationService } from "../../../domain/authentication";
import { AuthenticationService } from "..";
import { AuthenticationRepository } from ".";

export class AuthenticationRegistry implements IAuthenticationRegistry {
  getAuthenticationService(): IAuthenticationService {
    return new AuthenticationService(new AuthenticationRepository());
  }
}
